<template src="./list_item.html"></template>

<script>
import TopService from 'Services/TopService';
import Pagination from 'Components/pagination/Pagination.vue';

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tops: [],
      // pagination
      currentPage: 1,
      from: 0,
      to: 0,
      total: 0,
      perPage: 12,
      lastPage: 1,
      isLoading: true,
      i18n: 2,
      national: null,
    };
  },

  created() {
    this.listt();
  },

  methods: {
    listt() {
      this.isLoading = true;
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      this.national = this.$route.params.address;

      const params = {
        page: this.currentPage,
        limit: this.perPage,
        national: this.national,
        i18n: this.i18n,
      };

      TopService.listItem(params)
        .then((response) => {
          this.tops = response.data.data;
          this.from = response.data.from;
          this.to = response.data.to;
          this.total = response.data.total;
          this.lastPage = response.data.last_page;
        })
        .catch(() => {});
    },

    onPageChange(page) {
      this.currentPage = page;
      this.list();
    },
  },
};
</script>
